/* eslint-disable */
import React, { Component } from 'react';
import { injectStripe, CardElement } from 'react-stripe-elements';

import { Theme } from '../../config/theme';

class CheckoutForm extends Component {
  componentDidMount() {
    this.props.onRef(this)
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  verifyCard() {
    return new Promise((resolve, reject) => {
      this.props.stripe.createToken({
        first_name: this.props.first_name,
        last_name: this.props.last_name,
      }).then((response) => {
        console.log('Received Stripe token:', response);
        this.props.handler(response).then(() => {
          resolve(response);
        });
      });
    });
  }

  render() {
    return (
      <form style={{width: '100%',}}>
        <CardElement
          onChange={this.props.cardChangedHandler.bind(this)}
          style={{
            base: {
              fontSize: '18px',
              backgroundColor: Theme.white,
            }
          }} />
      </form>
    );
  }
}

export default injectStripe(CheckoutForm);



// WEBPACK FOOTER //
// ./src/components/CheckoutForm/index.js